import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { memo } from "react";
import { equals } from "ramda";
import { CheckboxFieldset } from "@interdependence-ui";
import { sort } from "utils/sort";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function SelectKeywordFilter(_ref) {
  var selected = _ref.selected,
    selectable = _ref.selectable,
    onChange = _ref.onChange;
  var options = selectable.map(function (keyword) {
    return _objectSpread(_objectSpread({}, keyword), {}, {
      checked: selected.includes(keyword.id)
    });
  });
  var sortedOptions = sort(function (option) {
    return option.label.toLowerCase();
  }, options);
  return /*#__PURE__*/_jsx(CheckboxFieldset, {
    id: "select-keyword-filter",
    legend: "Filtrera data p\xE5 nyckelord",
    name: "keyword",
    options: sortedOptions,
    ellipse: true,
    icon: "surgery",
    updateSelected: onChange
  });
}, function (prev, curr) {
  return equals(prev.selected, curr.selected) && equals(prev.selectable, curr.selectable);
});